import { GridColDef } from "@mui/x-data-grid-premium";
import { Grid } from "@mui/material";
import NewbornNutritionExamplesRows from "../model";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import NewbornNutrition from "../create";
import { useTranslate } from "src/locales";
import ByzGrdEditButton from "src/components/core-components/mui/buttons-grid/ByzGrdEditButton";
import ByzGrdDeleteButton from "src/components/core-components/mui/buttons-grid/ByzGrdDeleteButton";
import BaseMedCardList from "src/components/shared-components/medcard/BaseMedCardList";

//MUZUN;446217;25022025
const columns: GridColDef[] = [
  {
    field: "update",
    headerName: "Güncelle",
    width: 150,
    renderCell(params) {
      return <ByzGrdEditButton link={`edit/${params.row.id}`} />;
    },
  },
  { field: "date", headerName: "Tarih", flex: 1 },
  { field: "field1", headerName: "Alan 1", flex: 1 },
  { field: "field2", headerName: "Alan 2", flex: 1 },
  { field: "field3", headerName: "Alan 3", flex: 1 },
  { field: "field4", headerName: "Alan 4", flex: 1 },
  { field: "field5", headerName: "Alan 5", flex: 1 },
  {
    field: "delete",
    headerName: "Sil",
    flex: 1,
    renderCell: (params) => (
      <ByzGrdDeleteButton onClick={() => console.log(params.row.id)} />
    ),
  },
];

function NewbornNutritionList() {
  const { t } = useTranslate();
  
  return (
    <>
      <BaseMedCardList
        title={t("newborn-nutrition.title")}
        columns={columns}
        rows={NewbornNutritionExamplesRows}
        CreateComponent={NewbornNutrition}
        pageSize={10}
      />

      <ByzMuiTypography
        sx={{
          fontSize: 13,
          fontWeight: 400,
          whiteSpace: "nowrap",
          wordWrap: "break-word",
          margin: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid container spacing={1} style={{ width: "100%" }}>
          <Grid
            item
            xs={3}
            sx={{
              padding: "10px",
              color: "black",
            }}
          >
            <b>{t("newborn-nutrition.list-text")}</b>
            <br />
            <b>{t("newborn-nutrition.list-text2")}</b>
          </Grid>
        </Grid>
      </ByzMuiTypography>
    </>
  );
}

export default NewbornNutritionList;
